<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="NÓMINA ABIERTA" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                ref="master"
                modalWidth="70%"
                @action="masterAction"
                @params="paramsTable"
      >
        <template slot="customButton">
          <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <template>
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados"
                          :decorator="['id_emp', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Concepto')"
                          :formItemConfig="fiOptions"
                          endpoint="coc"
                          ref="concepto"
                          :decorator="['id_coc', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Tipo de pago')"
                          :formItemConfig="fiOptions"
                          endpoint="tpay"
                          :decorator="['tpay', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Unidad')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['und', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Valor base')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['base', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Valor')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['ammount', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Valor mda local')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['ammount_l', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                  <a-select v-decorator="['month', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="month_ in months_name" :key="month_.value">
                      {{ month_.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Año')" v-bind="fiOptions">
                  <a-select  :default-value="yearToday" v-decorator="['year', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="year_ in years" :key="year_">
                      {{ year_ }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Periodo de liquidación')">
                  <a-input-number :min="0" :max="99" v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['period', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Proceso')">
                  <a-input-number :min="0" :max="99999" v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['prc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Forma liq')">
                  <a-input
                    v-decorator="['fliq', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Tipo de liq')"
                            :formItemConfig="fiOptions"
                            endpoint="tliq"
                            :decorator="['tliq', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('ID de novedad')">
                  <a-input
                    v-decorator="['novelty_id', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Moneda')"
                            :formItemConfig="fiOptions"
                            :decorator="['currency', { rules: [{ required: false}] }]"
                            :params="code_currency">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha inicial')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['ini', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha final')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha del evento')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['eventdate', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('IDTcc')"
                            :formItemConfig="fiOptions"
                            endpoint="cc"
                            :decorator="['id_t_cc', { rules: [{ required: false, message: 'Valor requerido' }]}]">
                </g-dropdown>
              </a-col>
            </a-row>
          </template>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="DATOS GENERALES" key="1">
          <payroll-personal-info v-if="payrollInfo" :payrollInfo="payrollInfo"></payroll-personal-info>
          <span v-else>Seleccione una nómina para ver más.</span>
        </a-tab-pane>
        <a-tab-pane tab="DETALLE" key="2">
          <payroll-details v-if="payrollInfo" :payrollInfo="payrollInfo"></payroll-details>
          <span v-else>Seleccione una nómina para ver más.</span>
        </a-tab-pane>
        <a-tab-pane tab="ETIQUETA" key="3">
          <payroll-label v-if="payrollInfo" :payrollInfo="payrollInfo"></payroll-label>
          <span v-else>Seleccione una nómina para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-tab-pane>
    <a-tab-pane tab="NÓMINA CERRADA" key="2">
      <payroll-nom-cer></payroll-nom-cer>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        fileNameExcel: 'nomina',
        paramsT: {},
        endpointExcel: 'payroll_nomina/downloadExcel',
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        master: {
          endpoint: 'payroll',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID compañía', dataIndex: 'id_compania', sorter: true},
              {title: 'Compañía', dataIndex: 'compania_nombre', sorter: true},
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre del empleado', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'ID del concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Nombre del concepto', dataIndex: 'nombre_concepto', sorter: true},
              {title: 'Naturaleza', dataIndex: 'naturaleza_concepto', sorter: true},
              {title: 'Tipo de pago', dataIndex: 'tpay', sorter: true},
              {title: 'Unidad', dataIndex: 'und', sorter: true},
              {title: 'Valor base', dataIndex: 'base_desc', sorter: true},
              {title: 'Valor', dataIndex: 'ammount_desc', sorter: true},
              {title: 'Valor mda local', dataIndex: 'ammount_l_desc', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'Periodo', dataIndex: 'period', sorter: true},
              {title: 'Proceso', dataIndex: 'prc', sorter: true}
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {filter_parent_payroll: true}
      },
      payrollInfo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData, columns: this.master.tableSetup.columns}
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      yearsSelect () {
        for (let i = 1990; i <= (this.yearToday + 20); i++) {
          this.years.push(i)
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.id_t_legal_entity = action.record.id_t_legal_entity
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_coc)) {
                this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
              }
            })
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/Payroll.vue